import { CALL_API } from '../../middleware/api';
import { decamelizeKeys, camelizeKeys  } from 'humps';

const CALCULATE = 'calculate/REQUEST';
const CALCULATE_SUCCESS = 'calculate/LOAD_SUCCESS';
const CALCULATE_FAIL = 'calculate/LOAD_FAIL';

const NULL_RESULT = 'calculate/NULL_RESULT';

const initialState = {
  calculating: false,
  result: null,
  prevPayload: null
};


export const calculate = payload => (dispatch, getState) => {
  if (payload && payload.dateFrom && payload.dateTo) {
    const { company } = getState().user;
    const id = company? company.id : 0;
    return dispatch({
      [CALL_API]: {
        types: [CALCULATE, CALCULATE_SUCCESS, CALCULATE_FAIL],
        endpoint: `cart/${id}/calculate-row/`,
        method: 'POST',
        payload: decamelizeKeys(payload)
      }
    });
  } else if (getState().basket.result) {
    return (dispatch({
      type: NULL_RESULT
    }));
  }
}

export const recalculate = () => (dispatch, getState) => {
  const { prevPayload, result } = getState().basket;
  if (result && prevPayload) {
    dispatch(calculate(prevPayload));
  }
}


export default function reducer(state = initialState, action) {
  switch (action.type) {
    case NULL_RESULT:
      return {...state, result: null}

    case CALCULATE:
      return {...state, calculating: true, prevPayload: camelizeKeys(action.payload) }

    case CALCULATE_SUCCESS:
      return {...state, result: action.response, calculating: false}

    case CALCULATE_FAIL:
      return {...state, result: null, calculating: false}

    default: 
      return state
  }
};


// WEBPACK FOOTER //
// ./src/redux/modules/basket.js